import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { validateTidalLicense } from "@workwave-tidal/core/base";
function FormHeader(props) {
  const { title, subtitle, testId = "form-header-root" } = props;
  return /* @__PURE__ */ jsxs(Box, { paddingBottom: 4, paddingLeft: 4, paddingRight: 4, component: "header", "data-testid": testId, children: [
    /* @__PURE__ */ jsx(Typography, { component: "h1", variant: "h6", children: /* @__PURE__ */ jsx(Box, { fontWeight: 600, children: title }) }),
    /* @__PURE__ */ jsx(Typography, { variant: "caption", children: subtitle })
  ] });
}
validateTidalLicense();
export {
  FormHeader
};
//# sourceMappingURL=FormHeader.js.map
